import {
  FETCH_ACTUAL_BOOKINGS_SUCCESS,
  FETCH_TEMPORY_BOOKINGS_SUCCESS,
  CREATE_CONSULTATION_SUCCESS,
} from "../constants/new.consultaion.constants";
    
const INIT_STATE = {
  newConsultaionData: {
    consult_doctor_name: "",
    sessions: "",
    patient_id: null,
    note: "",
  },
  actualBookings: [],
  temporyBookings: [],
};
    
const newConsultaionInfo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case  FETCH_ACTUAL_BOOKINGS_SUCCESS: {
      return {
         ...state,
        actualBookings: action.actual_bookings,
      };
    }

    case FETCH_TEMPORY_BOOKINGS_SUCCESS: {
      return {
        ...state,
        temporyBookings: action.tempory_bookings,
      };
    }

    case CREATE_CONSULTATION_SUCCESS: {
      let all = Object.assign([], state.temporyBookings);
      all.push(action.payload.data)
      return {
          ...state,
          temporyBookings: all,
          newConsultaionData: INIT_STATE.newConsultaionData
      }
    }
   
    default:
      return state;
  }
};
    
export default newConsultaionInfo;